import React, {Component} from 'react'
import _ from 'lodash';

import StationList from './StationList/StationList'
import './AdminStations.css'

/*** REDUX  ****/
import * as nodeDetailsActions from '../../../actions/nodeDetails'
import * as nodeChartsActions from '../../../actions/nodeCharts'
import * as stationActions from '../../../actions/stations';


import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
/** REACT TOOLBOX ***/
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import {PropsRoute} from "../../Route";
import {Route, Switch, withRouter} from "react-router-dom";
import NotFound from "../../Route/error404";
import StationForm from "./StationForm/StationForm";


class AdminStations extends Component {
    constructor() {
        super();

        this.state = {
            content: false,
            stations: [],
            page: 0,
            count: 0,
            order: {
                active: false,
                status: [0, 0, 0, 0]
            }
        };

        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.handleSensorsPage = this.handleSensorsPage.bind(this);
        this.handleOrder = this.handleOrder.bind(this);
    }

    componentDidMount() {
        if (this.props.stations.stations && this.state.stations.length === 0) {
            let stations;
            let count;
            let content = true;

            stations = this.props.stations.stations;
            count = this.props.stations.count;


            this.setState({
                ...this.state,
                stations,
                count,
                content
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.stations !== prevProps.stations) {
            let stations = [];
            let count = 0;
            let content = true;

            if (this.props.stations) {
                this.props.stations.stations.forEach((station, key) => {
                    if (this.state.stations.length > key) {
                        if (!_.isEqual(_.omit(station, ['checked']), _.omit(this.state.stations[key], ['checked']))) {
                            if (station.id === this.state.stations[key].id)
                                station.checked = this.state.stations[key].checked;
                            stations.push(station);
                        } else {
                            stations.push(this.state.stations[key]);
                        }
                    } else {
                        stations.push(station);
                    }

                });
                count = this.props.stations.count;
            }

            this.setState({
                ...this.state,
                stations,
                count,
                content
            });
        }
    }

    handleSensorsPage(direction) {
        if (direction === "next" && this.props.sensors.count > this.state.page + 20) {
            this.setState({...this.state, page: this.state.page+20});
        }
        else if (direction === "previous" && this.state.page > 0) {
            this.setState({...this.state, page: this.state.page-20});
        }
    }

    handleOrder(key) {
        let newState = this.state.order;

        if (this.state.order.status[key] === 0) {
            newState.active = true;
            newState.status = [0, 0, 0, 0];
            newState.status[key] = 1;
        } else if (this.state.order.status[key] === 1) {
            newState.status = [0, 0, 0, 0];
            newState.status[key] = 2;
        } else {
            newState.active = false;
            newState.status = [0, 0, 0, 0];
        }

        this.setState({...this.state, order: newState});
    }

    handleCheckBoxChange(key) {
        let stations = this.state.stations;

        stations[key].checked = !stations[key].checked;

        this.setState({...this.state, stations});
    }

    render() {
        return (
            <ThemeProvider theme={theme}>
                <div className="row dashboardContent">
                    <Switch>
                        <PropsRoute exact path={"/admin/stations/details/:id"} component={StationForm}/>
                        <PropsRoute exact path="/admin/stations" component={StationList}
                                    stations={this.state.stations}
                                    handleCheckBoxChange={this.handleCheckBoxChange}
                                    count={this.state.count}
                                    page={this.state.page}
                                    order={this.state.order}
                                    handleSensorsPage={this.handleSensorsPage}
                                    handleOrder={this.handleOrder}
                                    content={this.state.content}/>
                        <Route path='*' component={NotFound}/>
                    </Switch>
                </div>
            </ThemeProvider>
        )
    }
}

const dashboardStateToProps = (state) => {
    return {
        stations: state.stations
    }
};

const dashboardDispatchToProps = (dispatch) => {
    return {
        nodeDetailsActions: bindActionCreators(nodeDetailsActions, dispatch),
        nodeChartsActions: bindActionCreators(nodeChartsActions, dispatch),
        stationActions: bindActionCreators(stationActions, dispatch)

    }
};
export default withRouter(connect(dashboardStateToProps, dashboardDispatchToProps)(AdminStations))



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminStations/index.js